// extracted by mini-css-extract-plugin
export var fadeIn = "_ba-0";